/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    let store = this.store;
    let model = this.modelFor('people/person/progressions');

    // levels, categories, subcategories and goals are required for
    // generating progress charts and details.
    model.categories = store.findAll('goals/category');
    model.expectations = store.findAll('milestones/expectation');
    model.goals = this.store.findAll('goals/goal');
    model.levels = store.findAll('milestones/level');
    model.progressions = store.query('milestones/progression', {
      personId: model.person.id,
      type: ProgressionType.PROGRESSION,
      latest: true,
    });
    model.subcategories = this.store.findAll('goals/subcategory');

    return hash(model);
  }
}
